import 'https://esm.archive.org/@internetarchive/reviews@1.1.0';
import { RecaptchaManager } from 'https://esm.archive.org/@internetarchive/recaptcha-manager@2.0.1';

/**
 * Adds a few necessary properties for the review component
 * @param {Element} reviewsComponent The reviews component
 */
function configureReviewsComponent(reviewsComponent) {
  // recaptcha-manager 2.x rejects getRecaptchaWidget() after `timeout` ms, where 1.x waited
  // forever. Its 10s default is tight for the slow international links this reCAPTCHA host
  // switch is meant to serve, and the review form treats that rejection as an unrecoverable
  // error, so a spurious timeout blocks submission outright. Allow more headroom.
  const recaptchaManager = new RecaptchaManager({
    defaultSiteKey: '6Ld64a8UAAAAAGbDwi1927ztGNw7YABQ-dqzvTN2',
    timeout: 30000,
  });
  // eslint-disable-next-line no-param-reassign
  reviewsComponent.recaptchaManager = recaptchaManager;

  const reviewsList = document.getElementById('reviews-list');
  if (!reviewsList) return;
  const reviews = JSON.parse(reviewsList.value ?? '[]');

  // eslint-disable-next-line no-param-reassign
  reviewsComponent.reviews = reviews;
}

/**
 * Hides the placeholder and shows and activates the add/edit button
 * @param {Element} reviewsComponent The reviews component
 */
function removeLoadingStates(reviewsComponent) {
  const reviewsPlaceholder = document.querySelector('.reviews-placeholder');
  if (reviewsPlaceholder) reviewsPlaceholder.style.display = 'none';

  const addEditButton = document.querySelector('.js-reviews-addEditReview');
  if (addEditButton) {
    addEditButton.style.display = 'block';
    addEditButton.addEventListener('click', () => {
      // eslint-disable-next-line no-param-reassign
      reviewsComponent.displayReviewForm = true;
    });
  }

  // eslint-disable-next-line no-param-reassign
  reviewsComponent.style.display = 'block';
}

/**
 * Updates the header and page review counts if a new review added
 */
function updateReviewCounts() {
  const addEditMessage = document.querySelector('.add-review-msg');
  if (addEditMessage) addEditMessage.innerText = 'Edit My Review';

  const reviewCount = document.querySelector('.review-count .item-stats-summary__count');
  const headerCount = document.querySelector('.header-review-count');

  if (!reviewCount) {
    if (headerCount) headerCount.innerText = '(1)';
    return;
  }

  const newReviewsCount = parseInt(reviewCount.innerText, 10) + 1;
  reviewCount.innerText = newReviewsCount;
  if (headerCount) headerCount.innerText = `(${newReviewsCount})`;
}

/** Sets up the reviews component */
document.addEventListener('DOMContentLoaded', () => {
  const reviewsComponent = document.querySelector('ia-reviews');
  if (!reviewsComponent) return;

  configureReviewsComponent(reviewsComponent);
  removeLoadingStates(reviewsComponent);

  reviewsComponent.addEventListener('newReviewAdded', () => {
    updateReviewCounts();
  });
});
